var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ch1\u003E404 - We are Sorry! \u003C\u002Fh1\u003E\u003Cp\u003E The page you were looking for can not be found.\u003C\u002Fp\u003E\u003Cproducts\u003E\u003C\u002Fproducts\u003E";;return pug_html;};
module.exports = template;